import styled from 'styled-components';

const Tooltip = styled.div`
  background-color: var(--purpleS);
  border-radius: var(--standard-radius);
  color: var(--white);
  display: none;
  font-size: var(--step-down-1);
  margin-left: -3.625rem;
  margin-top: -3rem;
  padding: 0.5rem 0.625rem 0.25rem;
  position: absolute;
  text-align: center;
  white-space: nowrap;
  &::after {
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-top: 0.625rem solid var(--purpleS);
    content: '';
    height: 0;
    margin-top: 1.5rem;
    position: absolute;
    right: calc(50% - 0.5rem);
    width: 0;
    z-index: 0;
  }
`;

export { Tooltip };



// WEBPACK FOOTER //
// ./src/components/base/Tooltip.js